<div class="row">
    <div class="col-sm-8">
        <div class="form-group row">
            <label class="control-label col-md-4">Type de la commande :</label>
            <div class="col-md-8">
                <p>{{orderTypeLabel}}</p>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-4">Souhaitée pour :</label>
            <div class="col-md-8">
                <p>{{orderProg | date :"HH:mm"}}</p>
            </div>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="control-label col-md-4">Adresse:</label>
            <div class="col-md-8">
                <p>
                    <span>{{address.streetNumber}} {{address.streetName}} ( {{address.city}}
                        {{address.postalCode}})</span>
                </p>
            </div>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="control-label col-md-4">Compléments d'adresse :</label>
            <div class="col-md-8">
                <textarea name="comment" placeholder="Batiment, Escalier, Etage, Porte, code, Interphone..."
                    [(ngModel)]="address.complementAddress" class="form-control" rows="4"></textarea>
            </div>
        </div>
        <div class="form-group row" *ngIf="enablePayement">
            <label class="control-label col-md-4">Paiement sécurisé:</label>
            <div class="col-md-8 add-margin">
                <div class="list list-options">
                    <div class="list-item brdb pbxl">
                        <input id="Cod_ParCB" name="payamentmode" [(ngModel)]="order.payamentmode"
                            class="osh-radio option" type="radio" [value]="1">
                        <label class="fwm" for="Cod_ParCB"><span class="-prm"><img src="assets/images/payement.png"
                                    alt=""></span>
                            Paiement par carte bancaire {{order.payamentmode}}</label>
                        <div class="subtitle">
                            Facile, sécurisé et permet d'éviter tout contact avec de la monnaie ou des
                            billets
                        </div>
                    </div>
                    <div class="list-item brdb pbxl">
                        <input id="Cod_CashOnDelivery" name="payamentmode" [(ngModel)]="order.payamentmode"
                            class="osh-radio option" type="radio" [value]="2">
                        <label class="fwm" for="Cod_CashOnDelivery"><span class="-prm"><img
                                    src="assets/images/service-cash.png" alt=""></span>
                            Paiement cash à la livraison {{order.payamentmode}}</label>
                        <div class="subtitle">
                            Payez en espèces dès que vous recevez votre commande.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="order.payamentmode==2 && payementModes.length > 0" class="form-group row">
            <label class="control-label col-md-4">Mode de réglement :</label>
            <div class="col-md-8 payementModes">
                <div class="check-group" *ngFor="let pm of payementModes;let i=index">
                    <input type="checkbox" [(ngModel)]="pm.checked" [id]="'pm'+i">
                    <label [for]="'pm'+i">
                        {{pm.text}}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-4">Vous avez un bon d'achat ?</label>
            <div class="col-md-8">
                <div class="input-group" [class.couponAdded]="couponAdded">
                    <input [disabled]="couponAdded" [(ngModel)]="coupon" type="text" style="padding: 10px!important;"
                        class="form-control" placeholder="Entrez ici votre coupon de réduction">
                    <span class="input-group-btn">
                        <button class="btn btn-default" *ngIf="!couponAdded" type="button" (click)="addCoupon()">Ajouter
                            le coupon</button>
                        <button class="btn btn-danger" *ngIf="couponAdded" type="button"
                            (click)="removeCoupon()">Retirer le coupon</button>
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-offset-4 col-md-8">
                <div class="d-flex justify-content-between" *ngIf="order.discount>0||order.fees>0|| order.coupon>0">
                    <p>
                        <b>Sous-total :</b>
                    </p>
                    <div>
                        {{order.amount | number : '1.2-2'}} €
                    </div>
                </div>
                <div class="d-flex justify-content-between" *ngIf="order.discount>0">
                    <p>
                        <b>Remise {{order.discount}}% :</b>
                    </p>
                    <div>
                        {{order.discountValue | number : '1.2-2'}} €
                    </div>
                </div>
                <div class="d-flex justify-content-between" *ngIf="order.coupon>0">
                    <p>
                        Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
                        <ng-container *ngIf="order.couponType==2">%</ng-container>
                    </p>
                    <div>
                        {{order.couponValue | number : '1.2-2'}} €
                    </div>
                </div>
                <div class="d-flex justify-content-between" *ngIf="order.fees>0">
                    <p>
                        <b>{{order.feesLabel}}:</b>
                    </p>
                    <div>
                        {{order.fees | number : '1.2-2'}}€
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <p>
                        <b>Total TTC :</b>
                    </p>
                    <p>
                        <b>{{order.total | number : '1.2-2'}} €</b>
                    </p>
                </div>
                <div class="validate">
                    <button (click)="save()" [disabled]='loader'>
                        <i class="flaticon-tick"></i>
                        <ng-container *ngIf="loader">
                            <i class='glyphicon glyphicon-refresh spinning'></i>
                            &nbsp;&nbsp;
                        </ng-container>
                        <span>Confirmer la commande {{order.total | number : '1.2-2'}} €</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <app-panier [showButton]="false" [updatePanier]="false"></app-panier>
    </div>
</div>